module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm1.654cb9742a8abadb3d386e186adc343c.png";